// extracted by mini-css-extract-plugin
export default {"layoutMainContainer":"style_layoutMainContainer__jDdEX"};